import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { RoutePath } from 'app/routing/routes';
import { AuthService } from 'app/_services/auth.service';
import { UserInfo, UserService } from 'app/_services/user.service';
import { Subscription } from 'rxjs';
import { ThemeService } from '../_services/theme.service';

@Component({
    selector: 'app-toolbar',
    templateUrl: './toolbar.component.html',
    styleUrls: ['./toolbar.component.scss'],
})
export class ToolbarComponent implements OnInit, OnDestroy {
    isDarkTheme: boolean;
    subscription: Subscription;
    user: UserInfo = null;
    role: string;

    @Output() toggleMenu = new EventEmitter();

    constructor(
        private router: Router,
        private themeService: ThemeService,
        private authService: AuthService,
        private userService: UserService
    ) {
        this.user = this.userService.UserValue;
        this.role = this.user?.CurrentRole.roleName;
    }

    ngOnInit(): void {
        this.subscription = this.themeService.isDarkTheme.subscribe(darkTheme => this.isDarkTheme = darkTheme);
    }

    onToggleMenu(): void {
        this.toggleMenu.emit();
    }

    onToggleDarkTheme(checked: boolean): void {
        this.themeService.setDarkTheme(checked);
    }

    login(): void {
        this.router.navigate([RoutePath.Login]);
    }

    logout(): void {
        this.authService.Logout();
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }
}
